module.exports = __webpack_public_path__ + "images/花筑pr长图_04-5.jpg?v=d8664fa6";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_04-5.jpg
 ** module id = 18
 ** module chunks = 1 2
 **/